module.exports = __webpack_public_path__ + "img/FT.2c071348.svg";